/* eslint-disable */
export default {
  allCalls: 'Tous les appels',
  Unknown: 'Inconnu',
  Multiple: 'Multiple',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
